import React, {Component} from 'react';

import axios from "axios";
import AuthService from "../../AuthService";
import Table from 'react-bootstrap/Table';
import DatePicker from "react-datepicker";

import {Grid} from 'react-loader-spinner'

import "react-datepicker/dist/react-datepicker.css";

class MailsTemplates extends Component {

    constructor(props) {
        super(props);

        this.state = {
            result: null,
            mailTemplateList: {},
            selectedTemplateId: null,
            selectedTemplate: null,
            mailSubject: null,
            mailBody: null,
            infos: []
        }
    }

    async componentDidMount() {
        await this.loadData(false);
    }

    async loadData() {
        this.setState({loading: true});
        await axios.post(AuthService.getUrl("/mailsTemplates"), {
        }, AuthService.getAuthHeader(this.state.locale)).then(async res => {
            await this.setState({
                result: res.return,
                mailTemplateList: res.data.data.mailTemplateList,
            });
        });
    }

    render() {
        if (this.state.result === null) {
            return (
                <div id="mailsTemplatesPage">
                    <div className="centerScreen">
                        <Grid
                            height="80"
                            width="80"
                            color="#4fa94d"
                            ariaLabel="grid-loading"
                            radius="12.5"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                        />
                    </div>
                </div>)
        } else {
            return (<div id="mailsTemplatesPage">
                        <div className="filter">
                            <label>Template :</label>
                            {<select className="value" type="text" name="ville" value={this.state.mailTemplateList} onChange={e => this.selectTemplate(e)}>
                                <option key={0} value={0}>---</option>
                                {this.state.mailTemplateList.map(mailTemplate => (
                                    <option key={mailTemplate.id} value={mailTemplate.id}>{mailTemplate.label}</option>
                                ))}
                            </select>}
                        </div>

                        {this.state.selectedTemplateId !== null &&
                            <div>
                                <form id="mailTemplateForm" onSubmit={e => this.submit(e)}>
                                    <div>
                                        <label className={"form-label"} htmlFor="id">Id:</label>
                                        <div className={"form-value"}>
                                            <input readOnly={true} type="text" id="id" name="id" value={this.state.selectedTemplate.id}></input>
                                        </div>
                                    </div>
                                    <br></br>
                                    <div>
                                        <label className={"form-label"}  htmlFor="label">Label:</label>
                                        <div className={"form-value"}>
                                            <input readOnly={true} type="text" label="label" name="label" value={this.state.selectedTemplate.label}></input>
                                        </div>
                                    </div>
                                    <br></br>
                                    <div>
                                        <label className={"form-label"}>Subject:</label>
                                        <div className={"form-value"} style={{"width": "300px"}}>
                                            <input key={this.state.selectedTemplate.id} type="text" defaultValue={this.state.selectedTemplate.mailSubject}
                                                   onChange={e => this.subjectChange(e)}></input>
                                        </div>
                                    </div>
                                    <br></br>
                                    <div>
                                        <label className={"form-label"}>Body:</label>
                                        <div className={"form-value"}>
                                            <textarea key={this.state.selectedTemplate.id} style={{"height": "1000px", "width": "800px"}} defaultValue={this.state.selectedTemplate.mailBody}
                                                      onChange={e => this.bodyChange(e)}></textarea>
                                        </div>
                                    </div>

                                    <div className="loginFormBox-line alignCenter">
                                        <button type="submit" className="formSubmit">Valider</button>
                                    </div>
                                    {this.state.infos.length > 0 && this.state.infos.map(info => (
                                        <div
                                            className="coreWorkflow-itemInfo">
                                            <p className="coreWorkflow-itemInfoMessage">{info.content}</p>
                                        </div>
                                    ))}
                                </form>
                            </div>
                        }
                    </div>
               )
        }
    }

    async selectTemplate(e) {
        e.preventDefault();

        const selectedTemplate = this.state.mailTemplateList.filter(mailTemplate => {
            return mailTemplate.id === parseInt(e.target.value)
        })[0];

        await this.setState({
            selectedTemplateId: e.target.value,
            selectedTemplate: selectedTemplate,
            mailBody: selectedTemplate.mailBody,
            mailSubject: selectedTemplate.mailSubject
        });
    }

    async submit(e) {
        e.preventDefault();

        let updatedTemplateMail = this.state.selectedTemplate;
        updatedTemplateMail.mailBody = this.state.mailBody;
        updatedTemplateMail.mailSubject = this.state.mailSubject;
        await axios.post(AuthService.getUrl("/saveMailTemplate"), {templateMail: updatedTemplateMail}, AuthService.getAuthHeader()).then(async res => {
            this.setState({
                infos: [{content: 'Données sauvegardées'}]
            })
        });
    }

    bodyChange(e) {
        this.setState({
            mailBody: e.target.value
        });
    }

    subjectChange(e) {
        this.setState({
            mailSubject: e.target.value
        });
    }
}

export default MailsTemplates;
